import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() title?: string;

  @Input() noContent?: boolean;

  @Input() borderTopLeftRadius?: string;

  @Input() borderTopRightRadius?: string;

  @Input() borderBottomRightRadius?: string;

  @Input() borderBottomLeftRadius?: string;

  // constructor() {}
}
